<template>
    <div id="billingForcastReport" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Billing Forecast Report</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content billing-forcast-report">
                        <data-table-filter-config :moduleName="'listBillingForecast'" ref="filterBillingForecast" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="bg-white mb-3">
                            <form class="form-horizontal basic-form-container contract-mapper" id="ContractAssetDetailForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col-md-3 form-group">
                                        <label class="control-label" for="contractTypeId">Contract Type:</label>
                                        <v-select multiple class="section-id" v-model="contractTypeId" name="contractTypeId" placeholder="Select Contract Type"
                                                    label="text" :options="contractTypeArr">
                                        </v-select>
                                        <div class="field-error">{{contTypeError}}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label require">Bill Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="billDate" name="billDate" v-model="billDate" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon" @input="onBillDateChange()"></date-picker>
                                            <label for="billDate" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{billDatesError}}</div>
                                    </div>
                                    <div class="col-md-1 form-group">
                                        <label class="control-label"></label>
                                        <div class="input-group">
                                            <label class="control-label w-100 text-center">OR</label>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label require">No. of Days</label>
                                        <div class="input-group">
                                            <input type="text" id="days" class="form-control" name="days" v-model="days" @input="onNoOfDaysChange()" @keypress="isIntegerCheck($event)"/>
                                        </div>
                                        <div class="field-error">{{daysError}}</div>
                                    </div>
                                    <div class="col-md-4 form-group">
                                        <label class="control-label">Last Updated At: {{lastUpdated}}</label>
                                        <div class="input-group">
                                            <button type="submit" id="searchBtn" :disabled="searchBtnDisabled" :value="searchBtnText" class="btn btn-secondary mr-2" v-on:click.prevent="loadReport('fetch')" >
                                                <i class="fp-accounting" v-if="searchBtnText == 'Fetch'"> </i> {{searchBtnText}}
                                            </button>
                                            <button type="button" id="resetBtn" class="btn btn-secondary mr-2" v-on:click="resetFilters" >
                                                <i class="fp-reload"> </i> Reset
                                            </button>
                                            <button type="button" id="confirmedBtn" class="btn btn-primary" v-on:click="confirmBilling" >
                                                <i class="fp-accounting"> </i> Confirmed
                                            </button>
                                            <!-- <a v-if="showGenerateInvoiceBtn" href="javascript:void(0)" class="btn btn-secondary ml-2" v-on:click="generateInvoice" >
                                                Generate Invoice
                                            </a> -->
                                        </div>
                                    </div>
                                </div>
                                <p v-if="batchProcess1" class="alert-success p-2" id="processFetchBatchMsg">Current batch {{batchNum1}} is processing please wait!</p>
                                <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                            </form>
                        </section>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <div class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :position="'top'"
                                          :moduleName="'billingForecastList'" ref="paginateComponent">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="billingForecastReport"
                                      mode="remote"
                                      title="Billing Forecast"
                                      @on-page-change="onPageChange"

                                      @on-column-filter="onColumnFilter"
                                      @on-row-click="onRowClick"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :sort-options="{
                                          enabled: false
                                      }"
                                      :select-options="{
                                          enabled: false,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                          enabled: false,
                                      }">
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange"
                                          :moduleName="'billingForecastList'">
                                  </custom-pagination>
                          </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

// import EventBus from "./event-bus";
import Vue from "vue";


import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import {dataTableMixins} from '../../mixins/dataTableMixins';
import VueSSE from 'vue-sse';
import EventBus from ".././event-bus";
Vue.use(VueSSE);
// import Echo from "laravel-echo";
// import VueSocketIO from 'vue-socket.io'

// window.io = require('socket.io-client');


let msgServer;
    export default {
        name: "billingForcastReport",
        mixins:[commonMixins,contractMixins,dataTableMixins],
        metaInfo() {
            return {
                title: "Billing Forecast Report | " +process.env.COPYRIGHT_NAME
            }
        },
        data: () => ({
            contTypeError:"",
            daysError:"",
            billDatesError:"",
            lastUpdatedAt:"",
            lastUpdated:"",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: true,
            searchBtnDisabled:false,
            searchBtnText:"Fetch",
            contractTypeArr:[],
            sectionArr:[],
            locationArr:[],
            customerArr:[],
            vehicleArr:[],
            customerId: null,
            unitId:null,
            contractTypeId:null,
            locationId:null,
            sectionId:null,
            billDate:"",
            userColumns:[],
            columns: [
                {
                    label: 'Contract Type',
                    field: 'contract_type',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Bill Date',
                    field: 'bill_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Bill Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Amount',
                    field: 'amount',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"integer",
                    type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'No. Of Customer',
                    field: 'number_of_customer',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"integer",
                    // type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "No. Of Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'No. Of Contract',
                    field: 'number_of_contract',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"integer",
                    // type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "No. Of Contract", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'No. Of Unit',
                    field: 'number_of_unit',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"integer",
                    // type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "No. Of Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }

            ],
            rows: [],
            selectedDate:"",
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            customer_value: false,
            loading:false,
            optionsDate:{
                            format: 'MM/DD/YYYY',
                            useCurrent: false,
                        },
            showGenerateInvoiceBtn:false,
            days:'',
            batchProcess1:false,
            batchId:0,
            batchNum1:'',
            action:'list',
            batchProcess:0,
            batchNum:"",
            batchError:false,
            batchErrorMsg:""
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'billing_forecast_report') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created : function () {
            let self = this;

            // if (typeof io !== 'undefined') {
            //     window.Echo = new Echo({
            //         broadcaster: 'socket.io',
            //         host: process.env.REDIS_HOST
            //     });
            // }

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            this.loadFieldData(['invcontractType']);
        },
        beforeDestroy() {
            // Make sure to close the connection with the events server
            // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.billingForecastReport.unselectAllInternal();
            },
            // exportReports: function() {
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },
            checkBatchStatus:function(){
                var self =  this;

                //  $.ajax({
                //     url: process.env.ROOT_API + "/check/batch-status/"+self.batchId,
                //     type: "GET",
                //     crossDomain: true,
                //     headers: {
                //         'Accept': 'application/json',
                //         "Authorization": "Bearer "+localStorage.getItem("tkn"),
                //         'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                //         "Cache-Control": "no-cache"
                //     },
                //     success: function(data) {
                //         self.loading = false;

                //         window.Echo.channel('batchStatus').listen('BatchStatusEvent', (e) => {
                //             console.log(e);
                //             if (e.status && (e.status == 1 || e.status == 2) ){
                //                 self.batchProcess1 = false;
                //                 self.loadList();
                //             }
                //         });
                //     },
                //     error: function(jqXHR, exception) {
                //         self.loading = false;
                //         self.generateStatusCodeMessage(jqXHR,false,'invoice-list');
                //     }
                // });

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess1 = false;
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            self.batchProcess1 = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },

            selectionChanged(param) {
                var self = this;

                var rowData = self.$refs['billingForecastReport'].selectedRows;

                if(rowData.length > 0){
                    if ( rowData.length > 1 ) {
                        alert("Please select only one row");
                        self.$refs['billingForecastReport'].unselectAllInternal();
                        self.showGenerateInvoiceBtn = false;
                        return;
                    }
                    self.showGenerateInvoiceBtn = true;
                }else{
                    self.showGenerateInvoiceBtn = false;
                }

                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }

            },

            generateInvoice() {

                var self = this;

                var filterArr = {};
                filterArr['customer'] = "";
                filterArr['contractTypeId'] = "";
                filterArr['location'] = "";

                filterArr['billDate'] = self.$refs['billingForecastReport'].selectedRows[0].date;
                filterArr['billFreq'] = self.$refs['billingForecastReport'].selectedRows[0].contract_type;

                if ( self.customerId != null && self.customerId.value ) {
                    filterArr['customer'] = self.customerId.value;
                }
                if ( self.contractTypeId != null && self.contractTypeId ) {
                    filterArr['contractTypeId'] = self.contractTypeId;
                }
                if ( self.locationId != null && self.locationId.value ) {
                    filterArr['location'] =  self.locationId.value;
                }

                self.generateBtnText = "Processing...";
                self.generatehBtnDisabled = true;

                $.ajax({
                    url: process.env.ROOT_API + "/invoice/generate",
                    type: "POST",
                    data: {filters:filterArr},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.generateBtnText = "Generate Invoice";
                        self.generatehBtnDisabled = false;

                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateBtnText = "Generate Invoice";
                        self.generatehBtnDisabled = false;

                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            onRowClick(params,event) {

                var self = this;
                if ( params.row.number_of_customer > 0 ) {
                    self.$router.push('/billing-forecast/detail/'+params.row.id);
                }else{
                    alert("No Record Found.");
                }


            },
            resetFilters() {

                this.customerId = null;
                this.unitId = null;
                this.contractTypeId = null;
                this.locationId = null;
                this.sectionId = null;
                this.billDate = "";
                this.days = '';
                // this.loadReport('list');
            },


            loadReport() {

                var self = this;
                var error = false;
                var filterArr = {};
                self.contTypeError = ""; self.daysError = ""; self.billDatesError = "";

                if ( self.contractTypeId != null && self.contractTypeId ) {
                    filterArr['contractType'] = self.contractTypeId;
                } else {
                    // self.contTypeError = "Please select contract type";
                    // error = true;
                }
                if ( self.billDate != null && self.billDate ) {
                    filterArr['billDate'] =  self.billDate;
                }
                if ( self.days != null && self.days ) {
                    filterArr['days'] =  self.days;
                }

                if ( self.days == "" && self.billDate == "" ) {
                // if (self.billDate == "" ) {
                    // self.daysError = "Please add no. of days";
                    self.billDatesError = "Please select bill date";
                    error = true;
                }
                if (self.days != '' && self.days > 60){
                    self.daysError = 'Days cannot be greater than 60';
                    error = true;
                }

                if ( error ) {
                    return;
                }

                self.searchBtnText = "Fetching...";
                self.searchBtnDisabled = true;
                $('#searchBtn').prop('disabled',true);

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/billing-forecast/fetch",
                    type: "GET",
                    data: filterArr,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.searchBtnText = "Fetch";
                        self.searchBtnDisabled = false;
                        $('#searchBtn').prop('disabled',false);
                        // console.log(data);
                        if (data.status == "success") {

                            if (data.code == 201){

                                self.batchProcess1 = true;
                                self.batchId = data.batchId;
                                self.checkBatchStatus();

                                setTimeout(function(){
                                    $("#processFetchBatchMsg").text('');
                                    $("#processFetchBatchMsg").text(data.message);
                                },100);
                            }else{

                                self.batchId = data.batchId;
                                self.batchNum1 = data.batchNumber;
                                self.batchProcess1 = true;
                                self.checkBatchStatus();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.searchBtnText = "Fetch";
                        self.searchBtnDisabled = false;
                        $('#searchBtn').prop('disabled',false);
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
             },

            loadList() {
                var self = this;

                var filterArr = {};

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    action:self.action
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/billing-forecast/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {
                                  if ( self.action == "export" ) {
                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }
                              }
                              self.action = "list";
                              self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.lastUpdated = data.lastUpdatedAt;

                                if (data.batchId){
                                    self.batchId = data.batchId;
                                    self.batchNum1 = data.batch;
                                    self.batchProcess1 = true;
                                    self.checkBatchStatus();
                                }
                            }

                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.lastUpdated = data.lastUpdatedAt;
                            if (data.batchId){
                                self.batchId = data.batchId;
                                self.batchNum1 = data.batch;
                                self.batchProcess1 = true;
                                self.checkBatchStatus();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            onBillDateChange() {
                var self = this;
                self.daysError = "";
                if (self.billDate != "" && self.billDate != null) {
                    self.days = "";
                }
            },
            onNoOfDaysChange() {
                var self = this;
                self.daysError = "";
                self.billDate = "";
                if (self.days != '' && self.days > 60){
                    self.daysError = 'Days cannot be greater than 60';
                }
            },
            confirmBilling:function(){
                var self = this;

                self.$router.push('/billing-forecast/detail?from=confirmed');
            }

        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/reports/BillingForecastReport.vue